/*eslint-disable*/
import React from "react";
import {
    Box,
    Flex,
    HStack,
    IconButton,
    Link,
    Text,
    useColorModeValue,
    VStack,
    Image,
} from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import wsClimaLogo from "assets/img/wsclima.png";

export default function Footer(props) {
    const footerBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");
    const textColor = useColorModeValue("gray.600", "gray.400");
    const mutedColor = useColorModeValue("gray.500", "gray.500");
    const linkHoverColor = useColorModeValue("brand.600", "brand.400");
    const socialBg = useColorModeValue("gray.100", "gray.700");

    return (
        <Box
            className="footer"
            bg={footerBg}
            borderTop="1px solid"
            borderColor={borderColor}
            mt={props.mt}
        >
            {/* Main Footer Content */}
            <Flex
                direction={{ base: "column", lg: "row" }}
                align={{ base: "center", lg: "flex-start" }}
                justify="space-between"
                maxW="1400px"
                mx="auto"
                px={{ base: 4, md: 8 }}
                py={6}
                gap={6}
            >
                {/* Company Info */}
                <VStack align={{ base: "center", lg: "flex-start" }} spacing={2}>
                    <Flex align="center" gap={2}>
                        <Image
                            src={wsClimaLogo}
                            alt="WS Clima Logo"
                            w="32px"
                            h="32px"
                            borderRadius="md"
                            objectFit="contain"
                        />
                        <Text fontWeight="bold" color={useColorModeValue("gray.700", "white")}>
                            WS Consultoria Climatológica
                        </Text>
                    </Flex>
                    <Text fontSize="xs" color={mutedColor} textAlign={{ base: "center", lg: "left" }}>
                        CNPJ 45.138.916/0001-40
                    </Text>
                </VStack>

                {/* Social Links */}
                <HStack spacing={3}>
                    <IconButton
                        as={Link}
                        href="https://www.facebook.com/william.siqueira.31/"
                        target="_blank"
                        aria-label="Facebook"
                        icon={<FaFacebook />}
                        size="md"
                        borderRadius="xl"
                        bg={socialBg}
                        color={textColor}
                        _hover={{
                            bg: "#1877F2",
                            color: "white",
                            transform: "translateY(-2px)",
                        }}
                        transition="all 0.2s ease"
                    />
                    <IconButton
                        as={Link}
                        href="https://www.instagram.com/owilliamsiqueira/"
                        target="_blank"
                        aria-label="Instagram"
                        icon={<FaInstagram />}
                        size="md"
                        borderRadius="xl"
                        bg={socialBg}
                        color={textColor}
                        _hover={{
                            bg: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
                            color: "white",
                            transform: "translateY(-2px)",
                        }}
                        transition="all 0.2s ease"
                    />
                    <IconButton
                        as={Link}
                        href="https://wa.me/5535991851089"
                        target="_blank"
                        aria-label="WhatsApp"
                        icon={<FaWhatsapp />}
                        size="md"
                        borderRadius="xl"
                        bg={socialBg}
                        color={textColor}
                        _hover={{
                            bg: "#25D366",
                            color: "white",
                            transform: "translateY(-2px)",
                        }}
                        transition="all 0.2s ease"
                    />
                </HStack>

                {/* Copyright */}
                <Text fontSize="sm" color={textColor} textAlign={{ base: "center", lg: "right" }}>
                    &copy; 2019 - {new Date().getFullYear()} |{" "}
                    <Text as="span" color={mutedColor}>
                        Desenvolvido por{" "}
                    </Text>
                    <Link
                        href="https://www.paulokramer.com"
                        target="_blank"
                        color={linkHoverColor}
                        fontWeight="medium"
                        _hover={{ textDecoration: "underline" }}
                    >
                        PK Systems
                    </Link>
                </Text>
            </Flex>
        </Box>
    );
}
